'use client';
var COMPONENT_ID = "BaseTypography";
var defaultProps = {
    variants: {}
};

export { COMPONENT_ID, defaultProps };
